'use strict';

const Backbone = require('dibs-backbone');
const SoaModel = require('bunsen/models/SoaModel');
const Permission = require('bunsen/models/identity/Permission');
const ends = require('dibs-endpoints');
const PublicationGroup = require('bunsen/models/inventory/PublicationGroup');
let PublicationType;
const TYPES = [
    'FEATURED_FURNITURE',
    'FEATURED_JEWELRY',
    'FEATURED_FASHION',
    'FEATURED_ART',
    'MARKETPLACE_FURNITURE',
    'MARKETPLACE_JEWELRY',
    'MARKETPLACE_FASHION',
    'MARKETPLACE_ART',
    'DEALER_STOREFRONT_FURNITURE',
    'DEALER_STOREFRONT_JEWELRY',
    'DEALER_STOREFRONT_FASHION',
    'DEALER_STOREFRONT_ART',
    'SATURDAY_SALE'
];

/**
 * Publication type is a complex object describing the type and group a publication belongs to.
 * For example, a publication that is feature in furniture would be type FEATURED_FURNITURE, and the type group would
 * be FEATURED
 * @type {Function}
 */
PublicationType = SoaModel.extend({
    relations : [
        {
            type: Backbone.One,
            key: 'group',
            relatedModel: PublicationGroup
        }
    ],

    url: function () {
        return ends.publicationType(this.get('id'));
    },
    getName() {
        return this.get('name');
    },
    isStorefront() {
        return this.get('group').isStorefront();
    },
    isMarketplace() {
        return this.get('group').isMarketplace();
    },
    isFeatured() {
        return this.get('group').isFeatured();
    },
    isSale() {
        return this.get('group').isSale();
    }
});

TYPES.forEach(function (type) {
    PublicationType[type] = type;
});

// permission needed to create a publication of the specified type
PublicationType.createPermissions = {
    FEATURED_FURNITURE : Permission.PERMISSION_PUB_CREATE,
    FEATURED_JEWELRY : Permission.PERMISSION_PUB_CREATE,
    FEATURED_FASHION : Permission.PERMISSION_PUB_CREATE,
    FEATURED_ART : Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_FURNITURE : Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_JEWELRY : Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_FASHION : Permission.PERMISSION_PUB_CREATE,
    MARKETPLACE_ART : Permission.PERMISSION_PUB_CREATE,
    SATURDAY_SALE : Permission.PERMISSION_PUB_CREATE_SAT_SALE
};

PublicationType.getCombinedName = function (type, vertical) {
    type = type.toUpperCase();

    // sale pubs are for all verticals, so type is just SATURDAY_SALE
    if (type === 'SALE') {
        return PublicationType.SATURDAY_SALE;
    }

    vertical = vertical.toUpperCase();
    return PublicationType[type + '_' + vertical];
};

module.exports = PublicationType;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/PublicationType.es.js